import {
    NavigationClient,
    type NavigationOptions,
} from "@azure/msal-browser";

export class MsalNavigationClient extends NavigationClient {
    async navigateInternal(
        url: string,
        options: NavigationOptions
    ): Promise<boolean> {
        console.log("MSAL navigateInternal", { url, options });

        // Stop MSAL from doing full-page navigation inside the SPA.
        // We'll handle post-login routing ourselves in AuthCallbackView.
        return false;
    }
}